<template>
  <div id="app">
    <AppHeader />
    <div class="content_wrapper">
      <router-view />
    </div>
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppFooter from "./components/AppFooter.vue";
import "normalize.css";

export default {
  name: "app",
  components: {
    AppHeader,
    AppFooter
  }
};
</script>

<style>
#app {
font-family: '游ゴシック',YuGothic,'ヒラギノ角ゴ Pro W3','Hiragino Kaku Gothic Pro','メイリオ',Meiryo,'ＭＳ Ｐゴシック',sans-serif;
  margin: 0;
  outline: 0;
  padding: 0;
  color:silver;
  background: transparent;
  background-color: #191919;
  border: 0;
  vertical-align: baseline;
}

.content_wrapper {
  position: relative;
  min-height: 70vh;
}
</style>
